import { render } from "./readingglass.vue?vue&type=template&id=ac47cef4"
import script from "./readingglass.vue?vue&type=script&lang=js"
export * from "./readingglass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__